export default {
  computed: {
    label: function() {
      return this.filter.label
    },
    listItems() {
      const taxonomies = this.$store.getters['productCatalog/getTaxonomies']
      let filterBy = this.filter.filterBy
      let filterOptions = this.products.reduce((filterOptions, item) => {
        if (Array.isArray(item[filterBy])) {
          item[filterBy].forEach(fieldValue => {
            if (!filterOptions.includes(fieldValue) && item[filterBy]) {
              filterOptions.push(fieldValue)
            }
          })
        }
        else {
          if (!filterOptions.includes(item[filterBy]) && item[filterBy]) {
            filterOptions.push(item[filterBy])
          }
        }
        return filterOptions
      }, [])
        .sort((a, b) => {
          if (taxonomies[filterBy]) {
            const aIndex = taxonomies[filterBy].findIndex(term => term.description === a)
            const bIndex = taxonomies[filterBy].findIndex(term => term.description === b)
            if (aIndex < 0) return 1
            if (bIndex < 0) return -1
            return aIndex - bIndex
          }
          if (a < b) return -1
          if (a > b) return 1
          return 0
        })
      return filterOptions
    }
  }
}
